export default "/images/vendor/flag-icons/flags/4x3/sz.svg?c4a379660ee206ab84280573d3d0017d";